import type { RouteObject } from 'react-router-dom';
import ConversationDetailPage from '../pages/ConversationDetailPage';
import InboxPage from '../pages/InboxPage';
import NewMessagePage from '../pages/NewMessagePage';

/** A conversation is addressed by its own id, never a participant's. */
export const conversationsRoutes: RouteObject[] = [
  { path: '/conversations', element: <InboxPage /> },
  { path: '/conversations/new', element: <NewMessagePage /> },
  { path: '/conversations/:conversationId', element: <ConversationDetailPage /> },
];
